import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap'
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import {VisibilityButton} from "./VisibilityButton";
import {MultiSelectContextMenu} from "../../components/common";
import {OrganizationForm} from "./OrganizationForm";
import {organizationActions} from "_actions";
import {connect} from "react-redux";
import Checkbox from '@mui/material/Checkbox';
import _ from "lodash";
import moduleStyles from "./Styles.module.css";

/**
 * @author Chris Okebata
 */

const styles = {
    label: {
        marginTop: '4px',
        fontSize: '14px'
    },

    bodyTextHolder: {
        display: "flex",
        alignItem: "center"
    },
};


class OrganizationModal extends Component {

    state = {
        messageNotification: false,
        qualityScore: false,
        selectedVisibility: "",
        languages: ["en"],
        shopifyRevenueTracking: false,
        gorgiasRevenueTracking: false,
        closeTicketsOnSource: false,
        hideInMobile: false,
        teamLead: [],
        csm: [],
        weeklyMetricsEmail: false,
        escalationsViaEmail: false,
        messageValidityDurationInDays: 0
    };

    componentDidMount() {
        const { organizationParam } = this.props;
        this.props.dispatch(organizationActions.getTeamLeads(organizationParam?.id));
        this.props.dispatch(organizationActions.getCSMs(organizationParam?.id));

        if(organizationParam) {
            this.setState({
                messageNotification: organizationParam.notifications,
                qualityScore: organizationParam.qualityScore,
                selectedVisibility: organizationParam.visibility,
                languages: organizationParam.languages,
                shopifyRevenueTracking: organizationParam.shopifyRevenueTracking,
                gorgiasRevenueTracking: organizationParam.gorgiasRevenueTracking,
                closeTicketsOnSource: organizationParam.closeTicketsOnSource,
                teamLead: organizationParam.teamLead,
                csm: organizationParam.csm,
                weeklyMetricsEmail: organizationParam.isWeeklyMetricsEmailEnabled,
                hideInMobile: organizationParam.hideInMobile,
                escalationsViaEmail: organizationParam.escalationsViaEmail,
                messageValidityDurationInDays: organizationParam.messageValidityDurationInDays
            });
        }

    }

    handleVisibility = (data) => {
        this.setState({
            selectedVisibility: data
        });
    };

    handleChange = event => {
        event.stopPropagation();
        this.setState({
            [event.target.value]: event.target.checked
        });
    };

    getLanguageCodes = () => {
        const { languageList } = this.props.languages;
        let languageCodes = languageList.map(language => language.value);
        return languageCodes;
    };

    handleLanguageCheckboxChange = (values) => {
        this.setState({
            languages: values
        })
    };

    handleTeamLeadChange = (values) => {
        this.setState({
            teamLead: {
                value: values.id,
                label: values.name,
                selectedCsm: "selectedTL"
            }
        })
    };
    handleCSMChange = (values) => {
        this.setState({
            csm: {
                value: values.id,
                label: values.name,
                selectedCsm: "selectedCsm"
            }
        })
    };
    handleOrgFormChanges = (e) => {
        if(e.hasOwnProperty('selectedTL')){
            this.handleTeamLeadChange(e);
        }
        else if(e.hasOwnProperty('selectedCsm')){
            this.handleCSMChange(e);
        }
    };

    triggerEscalationsViaEmail = () => {
        const { organizationParam } = this.props;
        this.props.dispatch(organizationActions.orgEscalationsViaEmail(organizationParam.id))
    }

    sendMetricsEmail = () => {
        const orgId = _.get(this.props, 'organizationParam.id');
        this.props.dispatch(organizationActions.sendMetricsEmail(orgId));
    }

    handleMessageValidityDurationChange = (event) => {
        this.setState({ messageValidityDurationInDays: event.target.value });
    }

    render () {

        const { onSave, onHide, show, headerText, buttonText, organizationParam} = this.props;

        let teamLeadList = [];
        let csmList = [];
        const teamLeadOptions = this.props.teamLead && this.props.teamLead.teamLeadList
        const csmOptions = this.props.csm && this.props.csm.csmList
        if (teamLeadOptions) {
            teamLeadList = teamLeadOptions.map((teamLead) => {
                return{
                    id: teamLead.userId,
                    name: teamLead.username,
                    selectedTL: "selectedTeamLead"
                }
            })
        }
        if (csmOptions) {
            csmList = csmOptions.map((csm) => {
                return {
                    id: csm.userId,
                    name: csm.username,
                    selectedCsm: "selectedCsm"
                }
            });
        }

        const payload = {
            visibility: this.state.selectedVisibility,
            messageNotification: this.state.messageNotification,
            qualityScore: this.state.qualityScore,
            languages: this.state.languages,
            shopifyRevenueTracking: this.state.shopifyRevenueTracking,
            gorgiasRevenueTracking: this.state.gorgiasRevenueTracking,
            closeTicketsOnSource: this.state.closeTicketsOnSource,
            teamLead: this.state.teamLead,
            csm: this.state.csm,
            weeklyMetricsEmail: this.state.weeklyMetricsEmail,
            hideInMobile: this.state.hideInMobile,
            escalationsViaEmail: this.state.escalationsViaEmail,
            messageValidityDurationInDays: this.state.messageValidityDurationInDays,
        };

        const disableButton = typeof this.state.selectedVisibility === 'undefined';

        const languageList = this.props.languages && this.props.languages.languageList;
        let languageCodes = [];
        if(languageList) {
            languageCodes = this.getLanguageCodes();
        }


        return (
            <Modal show={show} onHide={onHide} className="tms-modal-dialog">
                <Modal.Header closeButton>
                    <Modal.Title>{headerText}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={moduleStyles.bodyTextHolder}>
                        <div className={moduleStyles.visibility}>
                            <span>Visibility</span>
                        </div>
                    </div>

                    <div className={moduleStyles.selectVisibility}>
                        <VisibilityButton
                            text={'Closed'}
                            data={'CLOSED'}
                            selected={this.state.selectedVisibility}
                            setVisibility={this.handleVisibility}
                            organizationParam={organizationParam}
                        />

                        <VisibilityButton
                            text={'Featured'}
                            data={'FEATURED'}
                            selected={this.state.selectedVisibility}
                            setVisibility={this.handleVisibility}
                            organizationParam={organizationParam}
                        />

                        <VisibilityButton
                            text={'Private'}
                            data={'PRIVATE'}
                            selected={this.state.selectedVisibility}
                            setVisibility={this.handleVisibility}
                            organizationParam={organizationParam}
                        />

                        <VisibilityButton
                            text={'Public'}
                            data={'PUBLIC'}
                            selected={this.state.selectedVisibility}
                            setVisibility={this.handleVisibility}
                            organizationParam={organizationParam}
                        />
                    </div>

                    <div className={moduleStyles.bodyTextHolder}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Notifications</span>
                        </div>
                    </div>
                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'messageNotification'
                                    checked={this.state.messageNotification}
                                />
                            }
                            label="Messages"
                        />
                    </div>
                    <div className={moduleStyles.weeklyNotification}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'weeklyMetricsEmail'
                                    checked={this.state.weeklyMetricsEmail}
                                />
                            }
                            label="Weekly metrics email job"
                        />
                    </div>
                    {
                        !_.isEmpty(organizationParam) &&
                        <div className={moduleStyles.sendEmail}>
                            <Button onClick={this.sendMetricsEmail} className={`btn btn-default ${moduleStyles["btnPadding"]}`}>
                                Send email metrics manually
                            </Button>
                        </div>
                    }

                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Score</span>
                        </div>
                    </div>
                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'qualityScore'
                                    checked={this.state.qualityScore}
                                />
                            }
                            label="Quality score"
                        />
                    </div>

                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Shopify</span>
                        </div>
                    </div>
                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'shopifyRevenueTracking'
                                    checked={this.state.shopifyRevenueTracking}
                                />
                            }
                            label="Shopify revenue tracking"
                        />
                    </div>

                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Gorgias</span>
                        </div>
                    </div>

                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'gorgiasRevenueTracking'
                                    checked={this.state.gorgiasRevenueTracking}
                                />
                            }
                            label="Gorgias revenue tracking"
                        />
                    </div>

                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Tickets</span>
                        </div>
                    </div>
                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'closeTicketsOnSource'
                                    checked={this.state.closeTicketsOnSource}
                                />
                            }
                            label="Close tickets on source"
                        />
                    </div>
                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Mobile app setting</span>
                        </div>
                    </div>
                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={(event)=>{this.handleChange(event)}}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'hideInMobile'
                                    checked={this.state.hideInMobile}
                                />
                            }
                            label="Hide in mobile app"
                        />
                    </div>

                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Escalation setting</span>
                        </div>
                    </div>
                    <div className={moduleStyles.formControlContainer}>
                        <FormControlLabel
                            classes={{label: moduleStyles.label}}
                            control={
                                <Checkbox
                                    onChange={event => this.handleChange(event)}
                                    sx={{
                                        color: "#aeaeae",
                                        margin: '5px 0 0 -2px',
                                        '&.Mui-checked': {
                                            color: "#003300",
                                        },
                                    }}
                                    value = 'escalationsViaEmail'
                                    checked={this.state.escalationsViaEmail}
                                />
                            }
                            label="Escalations via email"
                        />
                    </div>

                    {
                        !_.isEmpty(organizationParam) &&
                        <div>
                            <div className={moduleStyles.msgSettings}>
                                <div className={moduleStyles.sectionTitle}>
                                    <span>Message setting</span>
                                </div>
                            </div>
                            <label htmlFor={'messageValidityDuration'} className={moduleStyles.duration}>
                                Validity duration in days:
                            </label> &nbsp;
                            <input
                                id={'messageValidityDurationInDays'}
                                type={'number'}
                                min={0}
                                value={this.state.messageValidityDurationInDays}
                                onChange={(event) => this.handleMessageValidityDurationChange(event)}
                            />
                        </div>
                    }

                    <div className={`${moduleStyles.bodyTextHolder} ${moduleStyles.mt30}`}>
                        <div className={moduleStyles.sectionTitle}>
                            <span>Languages</span>
                        </div>
                    </div>

                    <div className="register-page-context-menu">
                    <MultiSelectContextMenu
                            name="language"
                            fieldName="language"
                            type="text"
                            displayName={'Languages'}
                            options={languageList}
                            checkedOptions={this.state.languages}
                            ids={languageCodes}
                            displayAllItemsCheckbox={false}
                            handleChange={this.handleLanguageCheckboxChange}
                            component={MultiSelectContextMenu}
                        />
                    </div>

                   <OrganizationForm
                       teamLeadOptions={teamLeadList}
                       csmOptions={csmList}
                       handleChange={(e)=>{this.handleOrgFormChanges(e)}}
                   />

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide} className={`btn btn-default  ${moduleStyles["btnPadding"]}`}>Cancel</Button>
                    <Button bsStyle="success" className={moduleStyles.btnPadding}
                            onClick={() => onSave(payload)}
                            disabled={disableButton}>
                        {buttonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const { organizations: {organizationDetails: {teamLead, csm}} } = state;
    return {
        teamLead,
        csm
    }
}
const connectedOrganizationModal = connect(mapStateToProps)(OrganizationModal);
export { connectedOrganizationModal as OrganizationModal };